/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../services/internationalization/internationalization_data_dictionary.ts"/>

module DealerwareWebComponents {
    "use strict";
    declare let aptrinsic: (type: string, userInfo: Object, accountInfo?: Object) => void;

    export class LoginFormController {
        public static $inject: string[] = [
            'CurrentUser',
            '$dealerwareNotification',
            '$dealerwareInternationalizationData'
        ];

        public email: string;
        public password: string;
        public error: string;
        public loginSuccess: any;
        public loginError: any;
        public loginInProgress: boolean;
        public showResetPassword: boolean;
        public resetPasswordInProgress: boolean;
        public resetPasswordComplete: boolean;
        public labels: { generic?: string };

        constructor(public CurrentUser: any,
                    public $dealerwareNotification: any,
                    public $dealerwareInternationalizationData: DealerwareWebServices.DealerwareInternationalizationData) {
                        this.getLabels('errorMessages');
                    }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then(function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function() {}
            );
        }

        public clearError() : void {
            this.error = undefined;
        }

        public toggleResetPassword(show: boolean) : void {
            this.showResetPassword = show;
        }

        public resetPassword() : void {
            var _self = this;

            this.resetPasswordInProgress = true;

            this.CurrentUser.userModel.forgotPassword({
                data: { email: this.email },
                successCallback: () => {
                    _self.resetPasswordInProgress = false;
                    _self.resetPasswordComplete = true;
                },
                errorCallback: (response: any) => {
                    _self.resetPasswordInProgress = false;
                    _self.$dealerwareNotification.apiError(response);
                }
            });
        }

        public login() : void {
            var _self = this;

            if (this.showResetPassword) { return; }

            this.loginInProgress = true;

            this.CurrentUser.login({
                email: this.email,
                password: this.password,
                successCallback: (returnValue: any, response: any) => {
                    _self.loginInProgress = false;

                    if (_self.loginSuccess && angular.isFunction(_self.loginSuccess)) {
                        aptrinsic("identify", {  // returnValue.data corresponds to a user object
                            "id": returnValue.data.id,
                            "email": returnValue.data.email
                        });
                        _self.loginSuccess({ returnValue: returnValue, response: response });
                    }
                },
                errorCallback: (response: any) => {
                    _self.loginInProgress = false;
                    _self.error = _self.labels.generic;

                    if (_self.loginError && angular.isFunction(_self.loginError)) {
                        _self.loginError(response);
                    }
                }
            });
        }
    }

    getDealerwareWebComponentsModule().controller('LoginFormController', LoginFormController);

    export class LoginFormDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'LoginFormController';
        public controllerAs     : string    =   'loginFormController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            loginSuccess: '&',
            loginError: '&?'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/authentication/login_form_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    getDealerwareWebComponentsModule().directive('dealerwareLoginForm', () => new LoginFormDirective());
}